import type { SVGProps } from 'react';

export function ShieldIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <g clipPath="url(#clip0_6180_13674)">
        <path
          d="M12.1111 7.64417C12.3567 7.64417 12.595 7.67306 12.8333 7.70917V5.17417C12.8333 4.59639 12.4939 4.07639 11.9667 3.8525L7.99444 2.11917C7.62611 1.96028 7.20722 1.96028 6.83889 2.11917L2.86667 3.8525C2.33944 4.08361 2 4.60361 2 5.17417V7.77417C2 11.0531 4.31111 14.1225 7.41667 14.8664C7.81389 14.7725 8.19667 14.6353 8.57222 14.4692C8.07389 13.7614 7.77778 12.9019 7.77778 11.9775C7.77778 9.58695 9.72056 7.64417 12.1111 7.64417Z"
          fill="currentColor"
        />
        <path
          d="M12.1106 9.08789C10.5145 9.08789 9.22168 10.3807 9.22168 11.9768C9.22168 13.5729 10.5145 14.8657 12.1106 14.8657C13.7067 14.8657 14.9995 13.5729 14.9995 11.9768C14.9995 10.3807 13.7067 9.08789 12.1106 9.08789ZM12.1106 10.0846C12.5583 10.0846 12.9195 10.4529 12.9195 10.8934C12.9195 11.334 12.5511 11.7023 12.1106 11.7023C11.67 11.7023 11.3017 11.334 11.3017 10.8934C11.3017 10.4529 11.6628 10.0846 12.1106 10.0846ZM12.1106 13.9629C11.4389 13.9629 10.8539 13.6307 10.4928 13.1179C10.5289 12.5979 11.5833 12.3379 12.1106 12.3379C12.6378 12.3379 13.6922 12.5979 13.7283 13.1179C13.3672 13.6307 12.7822 13.9629 12.1106 13.9629Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6180_13674">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
